import React from 'react';
import { Typography, Paper } from '@material-ui/core';
import { SentimentVeryDissatisfied } from '@material-ui/icons';
import '../layout/style.css';

const NotFound = ({ location }) => (
  <Paper align="center">
    <SentimentVeryDissatisfied className="oopsIcon" />
    <Typography variant="display1">
      Page '{location.pathname}' not found!
    </Typography>
  </Paper>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js